export default `float s=2., e;
    for(int i=0;i++<8;){
      p=.5-abs(p);
      p.x < p.z?p=p.zyx:p;
      p.z < p.y?p=p.xzy:p;
      s*=e=1.6;
      p=abs(p)*e-vec3(.5,30.0,5.0);
      p.yz*=rotate2D(.3);
    }
    return length(p.xy)/s-.005;
  }`